/* eslint-disable */
import _ from 'underscore';
function run(app) {
  _.templateSettings = {
    interpolate: /\{\{(.+?)\}\}/g
  };
}
export default {
  run: run
};

